import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  HStack,
  Icon,
  Container,
  Divider,
  List,
  ListItem,
  ListIcon
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaHome, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import ContentLayout from '@layouts/ContentLayout';

const Unauthorized = () => {
  const navigate = useNavigate();

  const cardBg = '#111111';
  const iconBg = 'rgba(239, 68, 68, 0.1)';
  const iconColor = 'red.400';
  const headingColor = 'white';
  const textColor = 'gray.300';
  const dividerColor = 'gray.700';

  return (
    <ContentLayout>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minH={{ lg: '90vh' }}
        p={4}
      >
        <Container maxW="2xl">
          <VStack
            spacing={8}
            bg={cardBg}
            p={10}
            borderRadius="xl"
            boxShadow="lg"
          >
            {/* Icon Section */}
            <Box
              bg={iconBg}
              position="relative"
              borderRadius="full"
              w={32}
              h={32}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={FaLock} boxSize={16} color={iconColor} />
              <Box
                position="absolute"
                top="0"
                right="0"
                bg="red.500"
                borderRadius="full"
                w={8}
                h={8}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon as={FaShieldAlt} boxSize={4} color="white" />
              </Box>
            </Box>

            {/* Error Code */}
            <VStack spacing={2}>
              <Heading
                size="3xl"
                color={iconColor}
                fontWeight="extrabold"
              >
                403
              </Heading>
              <Heading size="xl" color={headingColor} fontWeight="semibold">
                Access Denied
              </Heading>
            </VStack>

            {/* Description */}
            <VStack spacing={4} maxW="md">
              <Text color={textColor} fontSize="lg" textAlign="center">
                You don't have the required permissions to access this page.
              </Text>

              <Divider borderColor={dividerColor} />

              {/* Helpful Information */}
              <VStack spacing={3} align="stretch" w="full" pt={2}>
                <Text color={textColor} fontSize="sm" fontWeight="semibold">
                  This could be because:
                </Text>
                <List spacing={2} fontSize="sm">
                  <ListItem display="flex" alignItems="center">
                    <ListIcon as={FaCheckCircle} color={iconColor} />
                    <Text color={textColor}>Your role doesn't have access to this resource</Text>
                  </ListItem>
                  <ListItem display="flex" alignItems="center">
                    <ListIcon as={FaCheckCircle} color={iconColor} />
                    <Text color={textColor}>You need additional permissions from an administrator</Text>
                  </ListItem>
                  <ListItem display="flex" alignItems="center">
                    <ListIcon as={FaCheckCircle} color={iconColor} />
                    <Text color={textColor}>This page is restricted to specific user roles</Text>
                  </ListItem>
                </List>
              </VStack>

              <Divider borderColor={dividerColor} />

              <Text color={textColor} fontSize="sm" textAlign="center">
                If you believe this is an error, please contact your administrator
                to request access.
              </Text>
            </VStack>

            {/* Action Buttons */}
            <HStack spacing={4} pt={4}>
              <Button
                leftIcon={<FaHome />}
                colorScheme="brand"
                size="lg"
                onClick={() => navigate('/')}
              >
                Go to Dashboard
              </Button>
            </HStack>
          </VStack>
        </Container>
      </Box>
    </ContentLayout>
  );
};

export default Unauthorized;
